import Header from "@components/Header/Header"
import { useNavigate } from "react-router"
import Switch from "@components/Switch/Switch"
import { usePayLinkStore } from "@stores/payLinkStore"
import { useTranslation } from "react-i18next"
import { Container, SettingItem, SettingLabel, SettingContent, SettingDescription } from "./AdvanceOptions.styles"

const AdvanceOptions = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isEnabled, togglePayLink } = usePayLinkStore()

  return (
    <Container>
      <Header
        title={t('advanceOptions.header').toUpperCase()}
        showBackButton={true}
        onBackClick={() => navigate('/settings')}
      />
      <SettingItem>
        <SettingContent>
          <SettingLabel>
            {t('advanceOptions.enablePayLink')}
          </SettingLabel>
          <SettingDescription>
            {t('advanceOptions.payLinkDescription')}
          </SettingDescription>
        </SettingContent>

        <Switch
          isActive={isEnabled}
          onChange={togglePayLink}
        />
      </SettingItem>
    </Container>
  )
}

export default AdvanceOptions